import Axios from "axios";
import labels from "./labels.json";
import _ from "lodash";
// import { states } from "./constants";
export const getErrorMessage = (error) =>
  error.message
    ? error.message
    : error.error && typeof error.error === "string"
      ? error.error
      : typeof error === "string"
        ? error
        : "Something went wrong!";

export const uploadToAws = async (url, file) => {
  return await new Promise(async (resolve, reject) => {
    try {
      const __ = await Axios.put(url, file);
      if (__) {
        resolve(url);
      } else {
        reject();
      }
    } catch (error) {
      reject(error);
    }
  });
};

export function getPartyLabelByStatus(status) {
  switch (status) {
    case "draft":
      return "Draft";
    case "underReview":
      return "Under Verification";
    case "active":
      return "Active";
    default:
      return _.startCase(status);
  }
}

export function getFileName(uri) {
  if (uri?.length) {
    const names = uri?.split("/");
    if (names.length) {
      return names[names.length - 1].split("?")[0];
    }
  }
}

export function getLabelByPartyStatus(status) {
  switch (status) {
    case "underReview":
      return labels.profile_filters.under_verification;
    case "draft":
      return labels.profile_filters.drafts;
    default:
      return labels.profile_filters.active;
  }
}

export function getCaseLabelByStatus({
  status,
  uploadedDocuments,
  subscriptionKind,
}) {
  switch (status) {
    case "draft":
      return "Draft";
    case "pendingRegistrationFee":
      return "Awaiting Payment";
    case "negotiationReached":
      return subscriptionKind === "adhoc" ? "Settled" : "Awaiting Payment";
    case "negotiationOngoing":
      return "Under Resolution";
    case "claimantPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Agreement";
    case "respondentPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Payment";
    case "awaitingRespondentAcceptance":
      return "Waiting For Respondent";
    case "bothPaidNegotiationSuccessFee":
      return uploadedDocuments && uploadedDocuments.length > 0
        ? "Settled"
        : "Awaiting Agreement";
    case "waitingForCaseApproval":
      return "Waiting For Case Approval";
    case "waitingForArbitratorConfirmation":
      return "Waiting for Arbitrator Confimation";
    default:
      return _.startCase(status);
  }
}

export function formatNumberToMetrics(value = "", unit = "") {
  if (!value || unit !== "INR") return value;

  var afterPoint = "";
  if (value.indexOf(".") > 0)
    afterPoint = value?.substring(value?.indexOf("."), value?.length);
  value = Math.floor(value);
  value = value?.toString();
  var lastThree = value?.substring(value.length - 3);
  var otherNumbers = value?.substring(0, value.length - 3);
  if (otherNumbers !== "") lastThree = "," + lastThree;
  var res =
    otherNumbers?.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
    lastThree +
    afterPoint;
  return res;
}

export const renderFeeKind = (value, { resolutionKind }) => {
  if (resolutionKind === "mediation") {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Mediation");
    }
    return value?.replace("Negotiation", "Mediation");
  } else if (resolutionKind === "negotiation") {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Negotiation");
    }
    return value?.replace("Negotiation", "Negotiation");
  } else {
    if (_.snakeCase(value) === "case_registration") {
      return value?.replace("Case", "Arbitration");
    }
    return value?.replace("Negotiation", "Arbitration");
  }
};

export const downloadWithDifferenFileName = (url, name) => {
  if (!name) name = url.split("\\").pop().split("/").pop();
  fetch(url, {
    headers: new Headers({
      Origin: window.location.origin,
    }),
    mode: "cors",
  })
    .then((response) => response.blob())
    .then((blob) => {
      let blobUrl = window.URL.createObjectURL(blob);
      forceDownload(blobUrl, name);
    })
    .catch((e) => console.error(e));
};

function forceDownload(blob, filename) {
  var a = document.createElement("a");
  a.download = filename;
  a.href = blob;
  a.target = "_blank";
  document.body.appendChild(a);
  a.click();
  a.remove();
}

/**
 * @description Function to parse time stamp
 * @param {*} data
 */
export const parseTimeStamp = (data) => {
  return data + "Z";
};

export const numberFormat = (value, currency) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: currency ? currency : "INR",
  }).format(value);

export function getFileNameDoc(uri) {
  if (uri?.length) {
    if (uri?.length > 1) {
      const names = uri?.map((item) => item?.split("/"));
      if (names.length) {
        return "Multiple";
      }
    } else {
      const names = uri?.map((item) => item?.split("/"));
      if (names.length) {
        return names.map((data) => data[data.length - 1]);
      }
    }
  }
}

export function randomAlphaNumeric() {
  let s = "";
  let length = 6;
  Array.from({ length }).some(() => {
    s += Math.random().toString(36).slice(2);
    return s.length >= length;
  });
  return s.slice(0, length);
}

export function convertTo12HourFormat(timeString) {
  // Parse the input time string
  const [hours, minutes] = timeString.split(":").map(Number);

  // Determine AM or PM
  const period = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  const formattedHours = hours % 12 || 12;

  // Create the formatted time string
  const formattedTime = `${formattedHours}:${minutes} ${period}`;

  return formattedTime;
}
